import { firestoreConnect } from 'fire-connect'
import { createSearchableItemDispatchers, createSearchableItemListeners } from '../fireConnectCommon'

import SearchableItemList from './SearchableItemList'

const options = {
  collectionName: 'gameTemplates',
  orderTopBy: 'playCount',
  itemType: 'Games',
  subTypes: ['myGames', 'topGames'],
  options: []
}
const addListeners = createSearchableItemListeners(options)
const addDispatchers = createSearchableItemDispatchers(options)

export default firestoreConnect(addListeners, addDispatchers)(SearchableItemList)
